import { userContextApi } from './api';

export const getDigitalFingerprint = () => userContextApi.get('fetch');

export const sentUserContext = (data) => userContextApi.post('save', data);
